import React, { useCallback, useEffect, useState } from "react";
import axios from "services/axios";
import { Link, useNavigate } from "react-router-dom";
import Button from "components/atoms/Button";
import FormInput from "components/atoms/FormInput";
import Alert from "components/atoms/Alert";
import { handleException } from "utils";
import Spinner from "components/atoms/Spinner";


const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [emailErr, setEmailErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [passSent, setPassSent] = useState(false);

  const requestTempPassword = useCallback(async (userData: any) => {
    try {
      const res = await axios.post(
        `https://pocket.seerbitapi.com/pocket/forgot-password`,
        userData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (res?.data?.responseCode === "00") {
        Alert("success", "Password Sent successfully");
        setLoading(false);
        setPassSent(true);
      }
    } catch (error) {
      setLoading(false);
      handleException(error);
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (email.length < 1) {
      setEmailErr("Please enter a valid email");
    }

    requestTempPassword({
      username: email
    })
  };

  useEffect(() => {
    if (passSent) {
      setTimeout(() => {
        navigate('/auth/reset_password', { state: { email: email } });
      }, 5000);
    }
  }, [passSent]);

  return (
    <>
      {!passSent ? (
        <form onSubmit={handleSubmit}>
          <span className="text-centerk flex flex-col gap-5">
            <p className="font-bold text-2xl leading-7  ">Forgot Password?</p>
            <p className="font-normal text-base leading-7 mb-5 text-Black2">
              Request a temporary password
            </p>
          </span>
          <span>
            <FormInput
              type="email"
              name="email"
              placeholder="example@gmail.com"
              inputStyle="border border-trannsparent text-Black2"
              label="Email Address"
              labelStyle="font-normal text-base l6 px-0 mx-0  text-Black2"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              validationErr={emailErr}
            />
          </span>
          <div>
            <Button
              btnType="submit"
              btnText={loading ? <Spinner text="Loading..." textStyle="text-white" /> : "Reset Password"}
              // btnStyle="bg-black text-white px-6 py-3 mt-12 w-full"
              btnStyle="mt-10 bg-black text-SecondaryAccent5 font-semibold text-sm leading-7 px-5 py-1 !rounded-lg w-full"
              onClick={() => { }}
              disabled={!email || loading}
            />
            <span className="flex justify-left mt-5">
              <Link
                to="/auth/login"
                className="text-DarkBg3 hover:text-DarkBg3 font-bold text-sm leading-7 hover:underline hover:transition-all"
              >
                Return to Login
              </Link>
            </span>
          </div>
        </form>
      ) : (
        <div className="flex flex-col gap-4">
          <span className="text-centerk flex flex-col gap-5">
            <p className="font-bold text-2xl leading-7">Check your Email or contact your admin</p>
            <p className="font-normal text-base leading-7 mb-5 text-Black2">
              We have sent a temporary password, please check your email or request the
              password from the Admin to Log in.
            </p>
            {/* <p className="font-normal text-base leading-7 mb-5 text-Black2">
              We have sent a temporary password to the Admin. Please request the
              password from the admin to Log in.
            </p> */}
          </span>
          <p>
            Mail was not recieved?{" "}
            {/* Admin didn’t get the mail?{" "} */}
            <span
              className="text-[#E90500] cursor-pointer"
              onClick={() => requestTempPassword({ username: email })}
            >
              Resend email{" "}
            </span>
          </p>
          <span className="font-bold">
            <Link
              to="/auth/login"
              className="text-DarkBg3 font-bold text-sm hover:underline hover:transition-all"
            >
              Back to Login
            </Link>
          </span>
        </div>
      )}
    </>
  );
};

export default ForgotPassword;
